document.addEventListener('DOMContentLoaded', () => {

  // --- 1. Header Transparent Scroll ---
  const headerWrapper = document.querySelector('.header-wrapper');

  if (headerWrapper) {
    const handleHeaderScroll = () => {
      const triggerHeight = window.innerHeight * 0.5;

      if (window.scrollY > triggerHeight) {
        headerWrapper.classList.remove('transparent');
      } else {
        headerWrapper.classList.add('transparent');
      }
    };

    window.addEventListener('scroll', handleHeaderScroll);
    handleHeaderScroll();
  }

  // --- 2. Footer Container Margin ---
  const containerMargin = () => {
    const window_width = window.innerWidth;
    const container = document.querySelector('.footer__blocks-wrapper');
    if (container) {
      const container_width = container.offsetWidth;
      const container_margin = -((window_width - container_width) / 2);
      const doc = document.documentElement;
      doc.style.setProperty('--container-margin', `${container_margin}px`);
    }
  }
  window.addEventListener('resize', containerMargin);
  containerMargin();

  // --- 3. External Links Open in New Tab ---
  document.querySelectorAll('a[href^="http"]').forEach(link => {
    if (link.hostname !== window.location.hostname) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
 
  // --- 4. Pause Videos on Modal Open ---
  function pauseAllVideos() {
    document.querySelectorAll('video').forEach(video => {
      if (!video.paused) {
        video.pause();
      }
    });
  }
  
  function resumePausedVideos() {
    document.querySelectorAll('video').forEach(video => {
      video.muted = true;
      video.play().catch(err => {
        console.warn('Could not resume video:', err);
      });
    });
  }
  
  document.querySelectorAll('product-modal, modal-dialog').forEach(modal => {
    const observer = new MutationObserver(() => {
      const isOpen = modal.hasAttribute('open');
      if (isOpen) {
        pauseAllVideos();
      } else {
        resumePausedVideos();
      }
    });
  
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  });

  // --- 5. Custom Slider Progress Bars ---
  function initSliderProgressBars() {
    // Added :not(.is-initialized) to prevent double-binding the observer
    const counters = document.querySelectorAll('.slider-counter:not(.is-initialized)');

    counters.forEach(counter => {
      counter.classList.add('is-initialized'); // Safeguard flag
      counter.classList.add('has-progress-bar');
      
      const currentSpan = counter.querySelector('.slider-counter--current');
      const totalSpan = counter.querySelector('.slider-counter--total');

      if (!currentSpan || !totalSpan) return;

      if (!counter.querySelector('.slider-progress-track')) {
        const track = document.createElement('div');
        track.className = 'slider-progress-track';
        const fill = document.createElement('div');
        fill.className = 'slider-progress-fill';
        track.appendChild(fill);
        counter.appendChild(track);
      }
      
      const fill = counter.querySelector('.slider-progress-fill');

      const updateProgressBar = () => {
        const current = parseInt(currentSpan.textContent.trim(), 10) || 1;
        const total = parseInt(totalSpan.textContent.trim(), 10) || 1; 
        
        const percentage = (current / total) * 100;
        fill.style.width = `${percentage}%`;
      };

      updateProgressBar();

      const observer = new MutationObserver(updateProgressBar);
      const config = { characterData: true, subtree: true, childList: true };
      observer.observe(currentSpan, config);
      observer.observe(totalSpan, config);
    });
  }

  // --- 6. Desktop Slider Dragging ---
  function initDesktopSliderDrag() {

    const sliders = document.querySelectorAll('slider-component .slider:not(.drag-initialized)');

    sliders.forEach((slider) => {
      slider.classList.add('drag-initialized');
      
      let isDown = false;
      let isDragging = false;
      let startX;
      let scrollLeft;

      slider.style.cursor = 'grab';

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        isDragging = false;
        slider.style.cursor = 'grabbing';
        
        slider.style.scrollSnapType = 'none';
        slider.style.scrollBehavior = 'auto'; 
        
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.style.cursor = 'grab';
        slider.style.scrollSnapType = ''; 
        slider.style.scrollBehavior = ''; 
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.style.cursor = 'grab';
        slider.style.scrollSnapType = ''; 
        slider.style.scrollBehavior = ''; 
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault(); 
        isDragging = true;
        
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1.5; 
        slider.scrollLeft = scrollLeft - walk;
      });

      slider.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }

  // --- 6.5 Initialize & Watch for Dynamic Injections ---
  
  // 1. Run once immediately for standard sections
  initSliderProgressBars();
  initDesktopSliderDrag();

  // 2. Watch the page for newly injected elements (like Product Recommendations)
  const dynamicContentObserver = new MutationObserver((mutations) => {
    let shouldReinit = false;
    
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          // Check if the injected node is an element and contains a slider
          if (node.nodeType === 1 && (node.matches('slider-component, product-recommendations') || node.querySelector('slider-component'))) {
            shouldReinit = true;
          }
        });
      }
    });

    // If a new slider block was detected, run the initializers again!
    if (shouldReinit) {
      initSliderProgressBars();
      initDesktopSliderDrag();
    }
  });

  // Start watching the body for changes
  dynamicContentObserver.observe(document.body, { childList: true, subtree: true });

  // --- 7. Smooth Scroll Anchor Links ---
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          const targetId = this.getAttribute('href');
          if (targetId === '#') return;

          const targetElement = document.querySelector(targetId);

          if (targetElement) {
              e.preventDefault();

              const header = document.querySelector('.header-wrapper') || document.querySelector('sticky-header');
              const offset = header ? header.offsetHeight : 100;

              const elementPosition = targetElement.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - offset;

              window.scrollTo({
                  top: offsetPosition,
                  behavior: "smooth"
              });
          }
      });
  });

  // --- 8. SizeGuideLightbox

  function initSizeGuideLightbox() {
    // 1. Find the "Size Comparison" accordion
    const accordions = Array.from(document.querySelectorAll('.product__accordion details'));
    const sizeAccordion = accordions.find(details => {
      const title = details.querySelector('.accordion__title');
      return title && title.textContent.toLowerCase().includes('size comparison');
    });

    if (!sizeAccordion) return; // Stop if the accordion doesn't exist

    // 2. Extract the image from the accordion
    const img = sizeAccordion.querySelector('.accordion__content img');
    if (!img) return; // Stop if there is no image
    
    // Grabs the image source (Shopify usually outputs this with a leading //)
    const sizeImageSrc = img.getAttribute('src'); 

    // 3. Find the "Size" label inside the product info
    const labels = Array.from(document.querySelectorAll('.product__info-container .form__label'));
    const sizeLabel = labels.find(label => label.textContent.toLowerCase().includes('size'));

    if (!sizeLabel) return; // Stop if the Size label doesn't exist

    // 4. Create the Info Bubble Icon
    const infoBubble = document.createElement('a');
    infoBubble.href = sizeImageSrc;
    infoBubble.className = 'size-guide-bubble'; 
    infoBubble.setAttribute('aria-label', 'View Size Guide');
    
    // Simple HTML span instead of an SVG
    infoBubble.innerHTML = '<span class="info">info</span>';

    // 5. Append the bubble to the label and align them
    sizeLabel.appendChild(infoBubble);
    sizeLabel.style.display = 'inline-flex';
    sizeLabel.style.alignItems = 'center';

    // 6. Initialize GLightbox on the new bubble
    const checkGLightbox = setInterval(() => {
      if (typeof GLightbox !== 'undefined') {
        clearInterval(checkGLightbox);
        const lightbox = GLightbox({
          selector: '.size-guide-bubble',
          touchNavigation: true,
          loop: false
        });
      }
    }, 100);
  }

  // Run the function
  initSizeGuideLightbox();
  
});